import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { TogglePanelComponent } from "@components/toggle-panel/toggle-panel.component";

@Component({
    selector: "rask-response-panel",
    templateUrl: "./response-panel.component.html",
    styleUrls: ["./response-panel.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TogglePanelComponent]
})
export class ResponsePanelComponent {
    @Input() label: string;
    @Input() show: boolean;
    @Input() message: string;
}
